"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Editor/FieldSettings.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* A field's settings, opened inside the field list (screens 7, 8 and 9). */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Toggle = require('web/components/Form/Toggle'); var _Toggle2 = _interopRequireDefault(_Toggle);

var _rules = require('./rules');

const COLUMN_TYPES = [
  { type: 'text', name: 'Text' },
  { type: 'time', name: 'Time' },
  { type: 'date', name: 'Date' },
  { type: 'initials', name: 'Initials' },
  { type: 'result', name: 'Result: Given, Refused, Missed' },
]

const DEFAULT_ROWS = { mode: 'next', count: 10, columns: [] }
const MAX_COLUMNS = 10

/* A day-column table (a medication log) asks when each dose was given and
 * whether it was given, refused or missed; columns staff already set stay. */
const withDayColumns = (columns) => [
  ...columns,
  ...(columns.some(c => c.type === 'time') ? [] : [{ id: crypto.randomUUID(), label: 'Time given', type: 'time'  }]),
  ...(columns.some(c => c.type === 'result') ? [] : [{ id: crypto.randomUUID(), label: 'Result', type: 'result'  }]),
].slice(0, MAX_COLUMNS)











const FieldSettings = ({ field, openedType, staffInTable, onChange, onRemove }) => {
  const set = (patch) => onChange({ ...field, ...patch })
  // Choices are typed one per line; blank lines stay while typing, and go on save.
  const [optionsText, setOptionsText] = _react.useState.call(void 0, (_nullishCoalesce(field.options, () => ( []))).join('\n'))

  const changeType = (type) => {
    const patch = { type }
    if (type === 'signature') Object.assign(patch, { required: true, filler: 'family' })
    if (type === 'rows' && !field.rows) patch.rows = DEFAULT_ROWS
    if (type !== 'date' && field.filler === 'auto') patch.filler = 'family'
    set(patch)
  }

  const label = (
    _react2.default.createElement('label', { className: "forms-editor--setting", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
      , _react2.default.createElement('span', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "Label")
      , _react2.default.createElement('input', {
        className: "forms-editor--input",
        value: field.label,
        autoFocus: !field.label,
        maxLength: 200,
        onChange: e => set({ label: e.target.value }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
      )
    )
  )

  const actions = (
    _react2.default.createElement('div', { className: "forms-editor--setting-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
      ,  field.check && (
        _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--primary" , onClick: () => onChange(field), __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, "Looks right"

        )
      )
      , _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onRemove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, "Remove")
    )
  )

  if (field.type === 'signature') {
    return (
      _react2.default.createElement('div', { className: "forms-editor--settings", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
        , _react2.default.createElement('p', { className: "forms-editor--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "The family types their full name. BloomText stamps it here with the date and time, and adds a signature page to the PDF. A signature is always required."


        )
        ,  label 
        ,  actions 
      )
    )
  }

  const rows = _nullishCoalesce(field.rows, () => ( DEFAULT_ROWS))
  const setRows = (patch) => set({ rows: { ...rows, ...patch } })
  const setColumn = (i, patch) =>
    setRows({ columns: rows.columns.map((c, j) => (j === i ? { ...c, ...patch } : c)) })

  return (
    _react2.default.createElement('div', { className: "forms-editor--settings", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
      ,  label 
      , _react2.default.createElement('div', { className: "forms-editor--setting-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
        , _react2.default.createElement('select', {
          className: "forms-editor--input forms-editor--select" ,
          'aria-label': "Type",
          value: field.type,
          // SAFETY: the options below are FIELD_TYPES.
          onChange: e => changeType(e.target.value ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}

          ,  _rules.FIELD_TYPES.map(t => (
            _react2.default.createElement('option', { key: t, value: t, __self: this, __source: {fileName: _jsxFileName, lineNumber: 106}}, _rules.TYPE_NAMES[t])
          ))
        )
        ,  field.type !== openedType && _react2.default.createElement('span', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "was " , _rules.TYPE_NAMES[openedType]) 
      )

      ,  field.type === 'date' && (
        _react2.default.createElement(_Toggle2.default, {
          label: "Fill in the date when the family signs"       ,
          isChecked: field.filler === 'auto',
          onChange: on => set({ filler: on ? 'auto' : 'family' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
        )
      )

      ,  field.filler !== 'auto' && (
        _react2.default.createElement('div', { className: "forms-editor--setting-line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
          , _react2.default.createElement('div', { className: "forms-editor--segments", role: "radiogroup", 'aria-label': "Who fills it"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
            ,  (['family', 'staff'] ).map(filler => (
              _react2.default.createElement('button', {
                key: filler,
                type: "button",
                role: "radio",
                'aria-checked': field.filler === filler,
                className: _classBuilder2.default.call(void 0, 'forms-editor--segment', field.filler === filler && 'forms-editor--segment--on'),
                onClick: () => set({ filler }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}

                ,  filler === 'family' ? 'Family' : 'Staff, before sending' 
              )
            ))
          )
          , _react2.default.createElement(_Toggle2.default, { label: "Required", isChecked: field.required, onChange: required => set({ required }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}} )
        )
      )

      ,  field.type === 'choice' && (
        _react2.default.createElement('label', { className: "forms-editor--setting", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
          , _react2.default.createElement('span', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}, "Choices, one per line"   )
          , _react2.default.createElement('textarea', {
            className: "forms-editor--input",
            rows: 4,
            value: optionsText,
            onChange: e => {
              setOptionsText(e.target.value)
              set({ options: e.target.value.split('\n').map(o => o.trim()).filter(Boolean) })
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
          )
        )
      )

      ,  field.type === 'rows' && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('p', { className: "forms-editor--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}, "Tables with repeatable rows are marked in green."       )
          , _react2.default.createElement('div', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}, "Each new row goes in"    )
          , _react2.default.createElement('div', { className: "forms-editor--choices", role: "radiogroup", 'aria-label': "Each new row goes in"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
            , _react2.default.createElement('button', {
              type: "button",
              role: "radio",
              'aria-checked': rows.mode === 'day',
              className: _classBuilder2.default.call(void 0, 'forms-editor--choice', rows.mode === 'day' && 'forms-editor--choice--on'),
              onClick: () => setRows({ mode: 'day', count: 31, columns: withDayColumns(rows.columns) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}

              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}, "The column for its day"    )
              , _react2.default.createElement('span', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}, "1 to 31"  )
            )
            , _react2.default.createElement('button', {
              type: "button",
              role: "radio",
              'aria-checked': rows.mode === 'next',
              className: _classBuilder2.default.call(void 0, 'forms-editor--choice', rows.mode === 'next' && 'forms-editor--choice--on'),
              onClick: () => setRows({ mode: 'next', count: rows.mode === 'next' ? rows.count : 10 }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}}

              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}, "The next empty row"   )
            )
          )
          ,  rows.mode === 'day' && (
            _react2.default.createElement('p', { className: "forms-editor--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}, "Size the table to cover only the day columns, 1 to 31: each row's initials go in its day's column."                   )
          )
          ,  rows.mode === 'next' && (
            _react2.default.createElement('label', { className: "forms-editor--setting forms-editor--setting--inline" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
              , _react2.default.createElement('span', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}, "Rows on the page"   )
              , _react2.default.createElement('input', {
                className: "forms-editor--input forms-editor--number" ,
                type: "number",
                min: 1,
                max: 100,
                value: rows.count,
                onChange: e => setRows({ count: Math.min(100, Math.max(1, Number(e.target.value) || 1)) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}
              )
            )
          )
          , _react2.default.createElement('label', { className: "forms-editor--setting", __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}
            , _react2.default.createElement('span', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 197}}, "Item name" )
            , _react2.default.createElement('input', {
              className: "forms-editor--input",
              value: _nullishCoalesce(rows.item, () => ( '')),
              maxLength: 100,
              placeholder: "Visit, Dose" ,
              onChange: e => setRows({ item: e.target.value }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}
            )
          )
          , _react2.default.createElement('div', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, "What a row asks for"    )
          ,  rows.columns.map((c, i) => (
            _react2.default.createElement('div', { key: c.id, className: "forms-editor--column", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
              , _react2.default.createElement('input', {
                className: "forms-editor--input",
                'aria-label': "Column label" ,
                value: c.label,
                maxLength: 100,
                placeholder: "Time given" ,
                onChange: e => setColumn(i, { label: e.target.value }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
              )
              , _react2.default.createElement('select', {
                className: "forms-editor--input forms-editor--select" ,
                'aria-label': "Column type" ,
                value: c.type,
                // SAFETY: the options below are COLUMN_TYPES.
                onChange: e => setColumn(i, { type: e.target.value  }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}

                ,  COLUMN_TYPES.map(t => _react2.default.createElement('option', { key: t.type, value: t.type, __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}, t.name)) 
              )
              , _react2.default.createElement('button', {
                type: "button",
                className: "forms-editor--icon-btn",
                'aria-label': "Remove column" ,
                onClick: () => setRows({ columns: rows.columns.filter((_, j) => j !== i) }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}}
, "×"

              )
            )
          ))
          ,  rows.columns.length < MAX_COLUMNS && (
            _react2.default.createElement('button', {
              type: "button",
              className: "forms-editor--link-btn",
              onClick: () => setRows({ columns: [...rows.columns, { id: crypto.randomUUID(), label: '', type: 'text' }] }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
, "Add a column"

            )
          )
          , _react2.default.createElement('p', { className: "forms-editor--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}, "Every row is stamped with the family's initials and the time it was added. Refused adds R and Missed adds M after the initials."


          )
          , _react2.default.createElement('div', { className: "forms-editor--setting-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}, "Filled once, by staff"   )
          , _react2.default.createElement('p', { className: "forms-editor--help", __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
            ,  staffInTable.length
              ? staffInTable.map(f => f.label || _rules.TYPE_NAMES[f.type]).join(', ')
              : 'Drop a Text field on the table for each item, such as Medication or Dose, and set it to Staff, before sending.' 
          )
        )
      )

      ,  actions 
    )
  )
}

exports. default = FieldSettings
